export default __webpack_public_path__ + "static/media/courseOnlineIcon.6d353fab.svg";